<app-notification-card iconName="help_outline" title="Confirmation Required">
  @switch (state()) {
    @case ('resolved-confirm') {
      <span notifBadge class="notification-badge mat-font-label-sm notification-badge--success">
        <mat-icon>check_circle</mat-icon>
        Confirmed
      </span>
    }
    @case ('resolved-decline') {
      <span notifBadge class="notification-badge mat-font-label-sm notification-badge--error">
        <mat-icon>cancel</mat-icon>
        Declined
      </span>
    }
    @case ('expired') {
      <span notifBadge class="notification-badge mat-font-label-sm notification-badge--pending">
        <mat-icon>timer_off</mat-icon>
        Expired
      </span>
    }
  }

  <!-- Engine-stamped ask context lives inside the card header while pending (HITL contract §2) -->
  @if (state() === 'pending') {
    <app-hitl-ask-context notifBadge [entry]="entry()" />
  }

  <!-- Prompt text -->
  <p class="mat-font-body-md mb-0">{{ entry().display_text }}</p>

  <!-- Actions -->
  @if (state() === 'pending') {
    <div class="d-flex gap-2">
      <button matButton (click)="confirm()">
        <mat-icon>check</mat-icon>
        Confirm
      </button>
      <button matButton="outlined" (click)="decline()">
        <mat-icon>close</mat-icon>
        Decline
      </button>
    </div>
  }

  @if (state() === 'expired') {
    <div class="d-flex flex-column gap-2">
      <p class="mat-font-body-sm mb-0 mat-text-on-surface-variant">This request has expired. Click Restart to try again.</p>
      <div>
        <button matButton="outlined" (click)="restart()">
          <mat-icon>refresh</mat-icon>
          Restart
        </button>
      </div>
    </div>
  }
</app-notification-card>
